import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BARKING_DOG_S3_URL = "https://virtual-customer-service-resources.s3.us-east-1.amazonaws.com";
const baseQuery = fetchBaseQuery({
    baseUrl: BARKING_DOG_S3_URL,
});

export const s3ApiSlice = createApi({
    baseQuery,
    tagTypes: ["kioskLanguage"],
    endpoints: () => ({}),
    reducerPath: "s3ApiSlice",
});
